  import { makeStyles } from '@material-ui/core/styles';
  import { deepPurple } from '@material-ui/core/colors';

  export default makeStyles((theme) => ({
    appBar: {
      borderRadius: 5,
      margin: '30px 0',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '15px 50px',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },
    heading: {
      color: theme.palette.primary.main,
      textDecoration: 'none',
      fontSize: '2em',
      fontWeight: 300,
    },
    image: {
      marginLeft: '10px',
      marginTop: '0px',
    },
    toolbar: {
      display: 'flex',
      justifyContent: 'flex-end',
      width: '400px',
      [theme.breakpoints.down('sm')]: {
        width: 'auto',
      },
    },
    profile: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '400px',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        width: 'auto',
        marginTop: 20,
        justifyContent: 'center',
      },
    },
    logout: {
      marginLeft: '20px',
      background:'#e63946'
    },
    userName: {
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
    },
    brandContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    purple: {
      color: theme.palette.getContrastText(deepPurple[500]),
      backgroundColor: deepPurple[200],
    },
  }));
